/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, August 21st 2022, 7:28:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useSplitNodeHandlers } from "service-builder/hooks";
import { useWorkflowContext } from "service-builder/providers";
import { HelperText } from "ui-widgets";
import { ActivationBranchList } from "./ActivationBranchList";

export const SplitNodeSettings = () => {
  const { onDeleteActivationBranchCallback, onSaveActivationBranchCallback } = useSplitNodeHandlers({
    useWorkflowContext,
  });

  return (
    <Box sx={{ width: "100%", padding: 4 }}>
      <Stack spacing={2}>
        <HelperText>
          Add outgoing branches below to enable your workflow to activate multiple tasks as the next step. You can set
          each branch to activate based on conditions you set or always activate regardless of any conditions.
        </HelperText>
        <ActivationBranchList
          onSaveActivationBranchCallback={onSaveActivationBranchCallback}
          onDeleteActivationBranchCallback={onDeleteActivationBranchCallback}
        />
      </Stack>
    </Box>
  );
};
